import type { ElementType } from 'react';

interface ProjectCardProps {
  title: string;
  href: string;
  description: string;
  tags: string[];
  Icon?: ElementType;
}

export default function ProjectCard({ title, href, description, tags, Icon }: ProjectCardProps) {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className="card rounded-lg p-5 block hover:no-underline">
      <h3 className="text-base font-semibold mb-2 inline-flex items-center gap-2">
        {Icon && <Icon size={20} weight="bold" aria-hidden="true" />}
        {title}
      </h3>
      <p className="text-sm text-secondary legible mb-3">{description}</p>
      <div className="flex flex-wrap gap-1.5">
        {tags.map((t) => (
          <span key={t} className="tag">{t}</span>
        ))}
      </div>
    </a>
  );
}
